import { Link, Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

export default function ArticuloCard({key, id, ciclo, codArticulo, isbn, nombre, precio}){
    const navigate = useNavigate();

    const handleLink = () => {
        navigate(`/articuloDetalle/${id}`)
    }

    return(
        <>  
            <div className="overflow-x-auto">
            <table>
                <tbody>
                <tr className="text-sky-300 text-[10pt] font-semibold border-b border-slate-400 hover:font-bold hover:text-yellow-300 cursor-pointer"
                    onClick={handleLink}
                >                
                    <td className="w-[80px] pl-4">{codArticulo}</td>
                    <td ><p className="w-[656px] pr-2 truncate">{nombre}</p></td>
                    <td className="w-[150px] pl-2">{ciclo}</td>
                    <td className="w-[180px]">{isbn}</td>
                    <td className="w-[100px]">{precio}</td>                
                </tr>
                </tbody>
            </table>
            </div>
        </>
    )
} //whitespace-nowrap overflow-hidden text-ellipsis